import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'motion/react';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import J1Page from './pages/J1Page';
import StudyAbroadPage from './pages/StudyAbroadPage';
import WorkingHolidayVisaPage from './pages/WorkingHolidayVisaPage';

/**
 * AnimatedRoutes is a separate component so we can call useLocation()
 * inside BrowserRouter context, which is required for AnimatePresence
 * to detect route changes and trigger exit animations.
 */
function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<HomePage />} />
        <Route path="/j1-internship" element={<J1Page />} />
        <Route path="/study-abroad" element={<StudyAbroadPage />} />
        <Route path="/working-holiday-visa" element={<WorkingHolidayVisaPage />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <AnimatedRoutes />
      </Layout>
    </BrowserRouter>
  );
}

export default App;
